// extracted by mini-css-extract-plugin
module.exports = {"feedIcon":"TemplateButton_feedIcon__3TV1p","feedText":"TemplateButton_feedText__3yMhx","feedContainer":"TemplateButton_feedContainer__1N9qn"};